import noScroll from "@/utils/noScroll.js";

// Виджет висит на самой мобильной шапке и отвечает за сендвич-переключатель
// шторки, закрытие шторки при открытии заявки и прятки шапки при скролле вниз.
export default function mobileHeader(header, data) {
    const menu = document.getElementById(data.menuId || "mobile-menu");
    const burger = header.querySelector(".mobile-header-burger");

    if (!menu || !burger) {
        return;
    }

    let isOpen = false;

    function openMenu() {
        if (isOpen) {
            return;
        }
        isOpen = true;
        menu.classList.add("open");
        header.classList.add("menu-open");
        header.classList.remove("hidden");
        burger.setAttribute("aria-expanded", "true");
        noScroll.hideScroll();
    }

    function closeMenu() {
        if (!isOpen) {
            return;
        }
        isOpen = false;
        menu.classList.remove("open");
        header.classList.remove("menu-open");
        burger.setAttribute("aria-expanded", "false");
        noScroll.showScroll();
    }

    burger.addEventListener("click", function () {
        isOpen ? closeMenu() : openMenu();
    });

    // Клик по затемнённому фону мимо шторки закрывает её
    menu.addEventListener("click", function (event) {
        if (event.target === menu) {
            closeMenu();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closeMenu();
        }
    });

    // Заявка открывается поверх — шторку при этом убираем
    window.addEventListener("openRequestPopup", closeMenu);

    // Порог, ниже которого мелкие подрагивания скролла игнорируем
    const threshold = parseInt(data.scrollThreshold) || 5;
    let lastY = window.scrollY;
    let ticking = false;

    function updateOnScroll() {
        ticking = false;

        const y = window.scrollY;
        const delta = y - lastY;

        if (Math.abs(delta) < threshold) {
            return;
        }

        // При открытой шторке и у самого верха шапку не трогаем
        if (!isOpen && y > header.offsetHeight) {
            header.classList.toggle("hidden", delta > 0);
        } else {
            header.classList.remove("hidden");
        }

        lastY = y;
    }

    window.addEventListener(
        "scroll",
        function () {
            if (!ticking) {
                window.requestAnimationFrame(updateOnScroll);
                ticking = true;
            }
        },
        { passive: true }
    );
}
